import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectBatchProcessData,
  selectBatchProcessFile,
  selectDeletedTeacherCourseFee,
  selectNotificationEmails,
  tryDeleteTeacherCourseFee,
  tryDownloadFile,
  tryGetBatchProcessDetail,
  tryPutNotificationEmails,
} from "../../store/slices/backoffice-teachers";
import {
  Alert,
  AlertTitle,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
  Box,
  Stack,
  Divider,
} from "@mui/material";
import { MoreHoriz, Download, ForwardToInbox, ArrowBack } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router";
import CustomColumnMenu from "../layout/grid-column-menu";
import { DataGrid } from "@mui/x-data-grid";
import ModalMessages from "../layout/modal-messages";
import NewChargeDrawer from "./drawer";
import { NumericFormat } from "react-number-format";
import SettlementAdministratorsSkeleton from "./skeleton";
import { v4 as uuidv4 } from "uuid";
import Spinner from "../layout/spinner";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const BackofficeSettlementAdministrator = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const queryParams = new URLSearchParams(location.search);
  const batchprocessid = queryParams.get("batchprocessid");
  const isEditable = queryParams.get("isEditable") === "true";
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //TRAE EL EL DETALLE DE UNA PRELIQUIDACIÓN
  const selectedBatchProcessData = useSelector(selectBatchProcessData);
  //TRAE EL DETALLE DE LA NOTIFICACION MASIVA
  const notificationEmails = useSelector(selectNotificationEmails);
  //TRAE EL DETALLE DEL EXPORTAR GRILLA
  const batchProcessFile = useSelector(selectBatchProcessFile);

  //MANEJO DE LA CONFIRMACION DE ENVIO DE MAILS
  const [openSuccessMailsDialog, setOpenSuccessMailsDialog] = useState(false);
  const [openConfirmationMailsDialog, setOpenConfirmationMailsDialog] =
    useState(false);
  //MANEJO DE LAS COLUMNAS
  const [rows, setRows] = useState([]);

  //MANEJO DEL DRAWER
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [dataDrawer, setDataDrawer] = useState(undefined);

  //MANEJO DE ELIMINACION DE GASTOS
  const deletedTeacherCourseFee = useSelector(selectDeletedTeacherCourseFee);
  const [openDeleteConfirmationDialog, setOpenDeleteConfirmationDialog] =
    useState(false);
  const [teacherCourseFeeId, setTeacherCourseFeeId] = useState(null);

  const fetchData = async () => {
    const action = await dispatch(tryGetBatchProcessDetail(batchprocessid));

    if (action.payload.data.isValid) {
      setRows(
        action.payload.data.data.map((x) => {
          return {
            teacher: x.teacher,
            month: x.month,
            processType: x.processType,
            totalHours: x.totalHours,
            amount: x.amount,
            cliPrecaseId: x.cliPrecaseId,
            notes: x.notes,
            teacherCourseFeeId: x.teacherCourseFeeId,
          };
        })
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    !openConfirmationDialog && fetchData();
  }, [openConfirmationDialog]);

  // ELIMINAR GASTO
  const deleteTeacherCourseFees = async (teacherCourseFeeId) => {
    const action = await dispatch(
      tryDeleteTeacherCourseFee(teacherCourseFeeId)
    );
    if (action.payload.data.isValid) setOpenConfirmationDialog(true);
  };

  //ENVIO DE NOTIFICACIONES MASIVAS VIA MAIL

  const sendNotificationEmails = async () => {
    const actionType = 2;
    const action = await dispatch(
      tryPutNotificationEmails({ batchprocessid, actionType })
    );

    if (action.payload.data.isValid) setOpenConfirmationMailsDialog(false);
  };

  //EXPORTA LA GRILLA
  const downloadFile = async () => {
    const action = await dispatch(tryDownloadFile(batchprocessid));
    if (action.payload.data.isValid) window.open(action.payload.data.data.file);
  };

  //ACCIONES
  const initializeDataGrid = () => {
    return {
      columns: {
        ...rows,
        ...columns,
        columnVisibilityModel: {
          cliPrecaseId: false,
          actions: isEditable,
          teacherCourseFeeId: false,
        },
      },
      pagination: { paginationModel: { pageSize: 10 } },
    };
  };

  const ActionsRow = ({ item }) => {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);

    const handleMenuItemClick = (event, index) => {
      //GENERAR GASTO
      if (index === 0) {
        setDataDrawer({
          batchprocessid: batchprocessid,
          cliPrecaseId: item.row.cliPrecaseId,
          teacher: item.row.teacher,
        });
        setOpenDrawer(true);
      }
      //ELIMINAR GASTO
      if (index === 1) {
        setTeacherCourseFeeId(item.row.teacherCourseFeeId);
        setOpenDeleteConfirmationDialog(true);
      }

      setOpen(false);
    };

    const handleToggle = () => {
      setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
      if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
      }

      setOpen(false);
    };

    return (
      <>
        <ButtonGroup
          variant="contained"
          ref={anchorRef}
          aria-label="split button"
        >
          <Button
            size="small"
            aria-controls={open ? "split-button-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-label="Acciones"
            aria-haspopup="menu"
            onClick={handleToggle}
          >
            <MoreHoriz />
          </Button>
        </ButtonGroup>
        <Popper
          sx={{
            zIndex: 1,
          }}
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          placement={isMobile ? "bottom-end" : "left"}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper elevation={6}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu">
                    <MenuItem
                      key="postTeacherCourseFees"
                      onClick={(event) => handleMenuItemClick(event, 0)}
                    >
                      Generar gasto
                    </MenuItem>

                    {item.row.teacherCourseFeeId !== 0 && (
                      <MenuItem
                        key="deleteTeacherCourseFees"
                        onClick={(event) => handleMenuItemClick(event, 1)}
                      >
                        Eliminar
                      </MenuItem>
                    )}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
    );
  };

  const columns = [
    {
      field: "cliPrecaseId",
      headerName: "cliPrecaseId",
      headerAlign: "center",
      align: "center",
      headerClassName: "headRow",
      flex: 1,
      filterable: false,
    },
    {
      field: "teacher",
      headerName: "Profesor",
      headerAlign: "center",
      align: "center",
      headerClassName: "headRow",
      flex: 1,
      filterable: false,
    },
    {
      field: "teacherCourseFeeId",
      headerName: "teacherCourseFeeId",
      headerAlign: "center",
      align: "center",
      headerClassName: "headRow",
      flex: 1,
      filterable: false,
    },
    {
      field: "month",
      headerName: "Mes",
      headerAlign: "center",
      align: "center",
      headerClassName: "headRow",
      flex: 1,
      filterable: false,
    },
    {
      field: "processType",
      headerName: "Tipo",
      headerAlign: "center",
      align: "center",
      headerClassName: "headRow",
      flex: 1,
      filterable: false,
    },
    {
      field: "totalHours",
      headerName: "Horas",
      headerAlign: "center",
      align: "center",
      flex: 1,
      filterable: false,
      headerClassName: "headRow",
    },
    {
      field: "notes",
      headerName: "Comentarios",
      headerAlign: "center",
      align: "center",
      flex: 1,
      filterable: false,
      headerClassName: "headRow",
    },
    {
      field: "amount",
      headerName: "Monto",
      headerAlign: "center",
      align: "center",
      flex: 1,
      filterable: false,
      headerClassName: "headRow",
      renderCell: (params) => (
        <NumericFormat
          key={`${params.field}_${params.id}`}
          value={params.value ?? 0}
          decimalScale={2}
          thousandSeparator="."
          displayType="text"
          decimalSeparator=","
          prefix="$"
          fixedDecimalScale
        />
      ),
    },

    {
      field: "actions",
      headerAlign: "center",
      align: "center",
      headerName: "",
      flex: 1,
      headerClassName: "headRow",
      filterable: false,
      renderCell: (params) =>
        deletedTeacherCourseFee.isLoading ? (
          <Spinner color="primary" />
        ) : (
          <ActionsRow item={params} />
        ),
    },
  ];

  return (
    <>
      {selectedBatchProcessData.isLoading ? (
        <SettlementAdministratorsSkeleton />
      ) : (
        <Box sx={{ px: { xs: 2, md: 3 }, py: 3, overflowX: "hidden" }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "flex-start", sm: "center" }}
                spacing={2}
              >
                <Button
                  variant="text"
                  size="medium"
                  startIcon={<ArrowBack />}
                  sx={{ fontWeight: "bold" }}
                  onClick={() => navigate("/backoffice/settlements")}
                >
                  VOLVER
                </Button>
                <Typography
                  align="left"
                  style={{ fontWeight: "bold", fontSize: 18 }}
                >
                  {isEditable ? `Administrar Preliquidación ${batchprocessid}` : ""}
                </Typography>
              </Stack>
            </Grid>

            {selectedBatchProcessData.data.length !== 0 ? (
              <>
                <Grid item xs={12}>
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="flex-end"
                    spacing={2}
                  >
                    <Button
                      variant="contained"
                      disabled={!isEditable || batchProcessFile.isLoading}
                      endIcon={<Download />}
                      onClick={() => downloadFile()}
                      fullWidth={isMobile}
                    >
                      {batchProcessFile.isLoading && <Spinner color="primary" />}
                      Exportar
                    </Button>
                    <Button
                      variant="contained"
                      disabled={!isEditable || notificationEmails.isLoading}
                      endIcon={<ForwardToInbox />}
                      onClick={() => {
                        setOpenSuccessMailsDialog(true);
                        setOpenConfirmationMailsDialog(true);
                      }}
                      fullWidth={isMobile}
                    >
                      {notificationEmails.isLoading && <Spinner color="primary" />}
                      Notificación Masiva
                    </Button>
                  </Stack>
                </Grid>

                <Grid item xs={12}>
                  {isMobile ? (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      {rows.map((row, index) => (
                        <Card key={index} elevation={3} sx={{ border: "1px solid #eee" }}>
                          <CardContent>
                            <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                              <Typography variant="subtitle1" fontWeight="bold" color="primary.main" sx={{ pr: 2 }}>
                                Prof. {row.teacher}
                              </Typography>
                              {isEditable && <ActionsRow item={{ row }} />}
                            </Box>

                            <Grid container spacing={1} sx={{ mb: 1 }}>
                              <Grid item xs={6}>
                                <Typography variant="caption" color="textSecondary" display="block">Mes</Typography>
                                <Typography variant="body2">{row.month || "-"}</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="caption" color="textSecondary" display="block">Tipo</Typography>
                                <Typography variant="body2">{row.processType || "-"}</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="caption" color="textSecondary" display="block">Total Horas</Typography>
                                <Typography variant="body2">{row.totalHours || "0"}</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="caption" color="textSecondary" display="block">Comentarios</Typography>
                                <Typography variant="body2">{row.notes || "-"}</Typography>
                              </Grid>
                            </Grid>

                            <Divider sx={{ my: 1 }} />

                            <Box display="flex" justifyContent="flex-end" alignItems="center" mt={1}>
                              <Box textAlign="right">
                                <Typography variant="caption" color="textSecondary" display="block">Monto</Typography>
                                <Typography variant="subtitle2" fontWeight="bold">
                                  <NumericFormat
                                    value={row.amount ?? 0}
                                    displayType="text"
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="$"
                                    decimalScale={2}
                                    fixedDecimalScale
                                  />
                                </Typography>
                              </Box>
                            </Box>
                          </CardContent>
                        </Card>
                      ))}
                    </Box>
                  ) : (
                    <DataGrid
                      slots={{
                        columnMenu: CustomColumnMenu,
                      }}
                      autoHeight={true}
                      rowSelection={false}
                      getRowId={(row) => uuidv4()}
                      disableRowSelectionOnClick
                      rows={rows}
                      columns={columns}
                      pageSizeOptions={[5, 10, 25, 50]}
                      initialState={initializeDataGrid()}
                      sx={{
                        "& .MuiDataGrid-virtualScroller": {
                          minHeight: 250,
                        },
                      }}
                    />
                  )}
                </Grid>
              </>
            ) : (
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  sx={{ textAlign: "left", marginBottom: 5 }}
                >
                  La preliquidación seleccionada no ha generado información
                </Alert>
              </Grid>
            )}
          </Grid>

          {openDrawer && (
            <NewChargeDrawer
              openDrawer={openDrawer}
              setOpenDrawer={setOpenDrawer}
              setOpenConfirmationDialog={setOpenConfirmationDialog}
              dataDrawer={dataDrawer}
            />
          )}

          {openConfirmationDialog && (
            <Dialog
              open={openConfirmationDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"La información ha sido guardada con éxito"}
              </DialogTitle>
              <DialogActions>
                <Button
                  onClick={() => setOpenConfirmationDialog(false)}
                  autoFocus
                >
                  Aceptar
                </Button>
              </DialogActions>
            </Dialog>
          )}

          {openSuccessMailsDialog && (
            <Dialog
              open={openSuccessMailsDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {!openConfirmationMailsDialog ? (
                  "La notificación ha sido enviada con éxito"
                ) : (
                  <Alert severity="warning" sx={{ textAlign: "left" }}>
                    <AlertTitle>
                      ¿Confirmas realizar una notificación masiva?
                    </AlertTitle>
                    Este proceso enviará un correo electrónico a todos los
                    profesores/as involucrados/as en la preliquidación con el
                    detalle de la misma.
                  </Alert>
                )}
              </DialogTitle>
              <DialogActions>
                <Button
                  disabled={notificationEmails.isLoading}
                  onClick={() =>
                    openConfirmationMailsDialog
                      ? sendNotificationEmails()
                      : setOpenSuccessMailsDialog(false)
                  }
                  autoFocus
                >
                  {notificationEmails.isLoading && (
                    <Spinner color="primary" />
                  )}
                  Aceptar
                </Button>
                {openConfirmationMailsDialog && (
                  <Button
                    disabled={notificationEmails.isLoading}
                    onClick={() => setOpenSuccessMailsDialog(false)}
                    autoFocus
                  >
                    Cancelar
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          )}

          {openDeleteConfirmationDialog && (
            <Dialog
              open={openDeleteConfirmationDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"¿Confirmas eliminar el gasto?"}
              </DialogTitle>
              <DialogActions>
                <Button
                  onClick={() => {
                    deleteTeacherCourseFees(teacherCourseFeeId);
                    setOpenDeleteConfirmationDialog(false);
                  }}
                  autoFocus
                >
                  Aceptar
                </Button>
                <Button
                  onClick={() => setOpenDeleteConfirmationDialog(false)}
                  autoFocus
                >
                  Cancelar
                </Button>
              </DialogActions>
            </Dialog>
          )}

          {selectedBatchProcessData.errors &&
            selectedBatchProcessData.errors.length > 0 && (
              <ModalMessages errors={selectedBatchProcessData.errors} />
            )}
          {deletedTeacherCourseFee.errors &&
            deletedTeacherCourseFee.errors.length > 0 && (
              <ModalMessages errors={deletedTeacherCourseFee.errors} />
            )}
          {notificationEmails.errors &&
            notificationEmails.errors.length > 0 && (
              <ModalMessages errors={notificationEmails.errors} />
            )}
          {batchProcessFile.errors && batchProcessFile.errors.length > 0 && (
            <ModalMessages errors={batchProcessFile.errors} />
          )}
        </Box>
      )}
    </>
  );
};

export default BackofficeSettlementAdministrator;